export default __webpack_public_path__ + "static/media/05_Lori_gorge.91e40052.jpg";